








import Vue from "vue";
import { Component } from "vue-property-decorator";
import { AssetClassificationDto } from "@/api/ClientPortalApiClient";
import ApiFactory from "../../api/ApiFactory";

@Component({})
export default class CbxAssetClassification extends Vue {
  private types: AssetClassificationDto[] | null = [];
  public selectedType = new AssetClassificationDto();

  public created() {
    this.getAvailableTypes();
  }

  public setSelected(type: AssetClassificationDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  public typeSelected(type: AssetClassificationDto) {
    this.$emit("assetClassificationSelected", type);
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .assetClassification_IndexAll()
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
